import { render, staticRenderFns } from "./ReportFormV2.vue?vue&type=template&id=2a276ee0"
import script from "./ReportFormV2.vue?vue&type=script&lang=js"
export * from "./ReportFormV2.vue?vue&type=script&lang=js"
import style0 from "./ReportFormV2.vue?vue&type=style&index=0&id=2a276ee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports